module.exports = __webpack_public_path__ + "img/bannerText2.5cbb9adf.png";